import { useAuth0 } from '@auth0/auth0-react';

import {
  useGetPersonAttributesQuery,
  useCurrentPersonUserQuery,
  useGetPersonByIdQuery,
  useGetPersonAccountProfileQuery,
} from 'store/api/pkd/endpoints/person';
import { useGetAuth0MetadataQuery } from 'store/api/pkd/endpoints/user';

export const useGetPersonAndAttributes = () => {
  const { user: auth0User, isLoading: auth0IsLoading } = useAuth0();

  const {
    personId,
    userId,
    personUser,
    isCurrentPersonLoading,
    isCurrentPersonFetching,
    isNewUser,
    refetch: refetchPerson,
  } = useCurrentPersonUserQuery(undefined, {
    skip             : auth0IsLoading,
    selectFromResult : ({ data, isLoading, isFetching, error }) => ({
      personId                : data?.data?.attributes?.personId?.toString(),
      userId                  : data?.data?.id,
      personUser              : data?.data,
      isCurrentPersonLoading  : isLoading,
      isCurrentPersonFetching : isFetching,
      isNewUser               : error?.status === 401,
    }),
  });

  const { personAccountProfileId } = useGetPersonAccountProfileQuery(
    { personId },
    {
      skip             : auth0IsLoading || !personId,
      selectFromResult : ({ data }) => ({
        data2                  : data?.data[0],
        personAccountProfileId : data?.data?.[0]?.id?.toString(),
      }),
    }
  );

  const { userMetaData, isLoading: isUserMetadataLoading } = useGetAuth0MetadataQuery(
    { userId },
    {
      skip             : !userId,
      selectFromResult : ({ data }) => ({
        userMetaData : data
      }),
    }
  );

  const { personState, isPersonDataLoading, isPersonFetching } =
  useGetPersonByIdQuery(
    { personId },
    {
      skip             : isCurrentPersonLoading || !personUser || !personId,
      selectFromResult : ({ data, isLoading, isFetching }) => ({
        personState         : data?.data?.attributes,
        isPersonDataLoading : isLoading || !data,
        isPersonFetching    : isFetching,
      }),
    }
  );

  const {
    data:personAttributes = [],
    isPersonAttributesLoading,
    isPersonAttributesFetching,
  } = useGetPersonAttributesQuery(
    { personId },
    {
      skip : isCurrentPersonLoading || !personUser || !personId,
    }
  );
  
  const isPersonLoading =
    auth0IsLoading ||
    isCurrentPersonLoading ||
    isPersonDataLoading ||
    isPersonAttributesLoading;
    
  const person = {
    user       : personUser,
    state      : personState,
    attributes : personAttributes,
  };
  return {
    auth0User,
    userMetaData,
    person,
    personId,
    userId,
    isCurrentPersonLoading,
    isUserMetadataLoading,
    auth0IsLoading,
    isPersonAttributesLoading,
    isPersonAttributesFetching,
    isCurrentPersonFetching,
    isPersonLoading,
    isPersonFetching,
    isNewUser,
    personAccountProfileId,
    refetchPerson,
  };
};
